import { getDb } from '../../core/db';
import type { PersonalSkin, SkinCacheEntry, SkinSelection } from './types';

export const APPEARANCE_SELECTION_KEY = 'zxtalk.appearance.selection.v2';
export const APPEARANCE_SETTINGS_KEY = 'zxtalk.appearance.v1';

export function loadSelection(): SkinSelection | null {
  try {
    const raw = globalThis.localStorage?.getItem(APPEARANCE_SELECTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SkinSelection>;
    if ((parsed.kind !== 'official' && parsed.kind !== 'personal') || typeof parsed.id !== 'string') return null;
    return {
      kind: parsed.kind,
      id: parsed.id,
      ...(typeof parsed.version === 'number' ? { version: parsed.version } : {}),
      overrides: parsed.overrides !== null && typeof parsed.overrides === 'object' ? parsed.overrides : {},
    };
  } catch {
    return null;
  }
}

export function saveSelection(selection: SkinSelection | null): void {
  try {
    if (selection === null) globalThis.localStorage?.removeItem(APPEARANCE_SELECTION_KEY);
    else globalThis.localStorage?.setItem(APPEARANCE_SELECTION_KEY, JSON.stringify(selection));
    globalThis.localStorage?.setItem(APPEARANCE_SETTINGS_KEY, JSON.stringify(selection?.overrides ?? {}));
    window.dispatchEvent(new CustomEvent('zxtalk:appearance-changed'));
  } catch {
    // Storage may be unavailable in private mode; the in-memory skin remains usable.
  }
}

export async function listPersonalSkins(): Promise<PersonalSkin[]> {
  return getDb().appearancePersonalSkins.orderBy('updatedAt').reverse().toArray();
}

export async function getPersonalSkin(id: string): Promise<PersonalSkin | undefined> {
  return getDb().appearancePersonalSkins.get(id);
}

export async function putPersonalSkin(skin: PersonalSkin): Promise<void> {
  await getDb().appearancePersonalSkins.put(skin);
}

export async function deletePersonalSkin(id: string): Promise<void> {
  await getDb().appearancePersonalSkins.delete(id);
}

export async function cacheSkin(entry: SkinCacheEntry): Promise<void> {
  await getDb().appearanceSkinCache.put(entry);
}

export async function cachedSkin(id: string): Promise<SkinCacheEntry | undefined> {
  return getDb().appearanceSkinCache.get(id);
}

